import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils";
const alertVariants = cva("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
    variants: {
        variant: {
            default: "bg-background text-foreground",
            destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
        },
        colorScheme: {
            default: "",
            info: "border-info-line bg-info-surface text-info [&>svg]:text-info",
            bliksy: "border-bliks-green-500/30 bg-bliks-green-surface text-bliks-green-800 [&>svg]:text-bliks-green-800",
            warning: "border-warning-line bg-warning-surface text-warning [&>svg]:text-warning",
            error: "border-danger-line bg-danger-surface text-danger [&>svg]:text-danger"
        }
    },
    defaultVariants: {
        variant: "default",
        colorScheme: "default"
    }
});
const Alert = /*#__PURE__*/ React.forwardRef(({ className, variant, colorScheme, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        role: "alert",
        className: cn(alertVariants({
            variant,
            colorScheme
        }), className),
        ...props
    }));
Alert.displayName = "Alert";
const AlertTitle = /*#__PURE__*/ React.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ _jsx("h5", {
        ref: ref,
        className: cn("mb-1 font-medium leading-none tracking-tight", className),
        ...props,
        children: children
    }));
AlertTitle.displayName = "AlertTitle";
const AlertDescription = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: cn("text-sm [&_p]:leading-relaxed", className),
        ...props
    }));
AlertDescription.displayName = "AlertDescription";
export { Alert, AlertTitle, AlertDescription };

//# sourceMappingURL=alert.js.map